export const environment = {
  production: true,
  buildId: '3283494744721131',
  configFile: 'config.json',
};
